// extracted by mini-css-extract-plugin
export var buttonRoot = "ButtonBlock-module--buttonRoot--2b2b2";
export var group = "ButtonBlock-module--group--a36af";